import { render, staticRenderFns } from "./CustomerEditQuotation.vue?vue&type=template&id=62007d40"
import script from "./CustomerEditQuotation.vue?vue&type=script&lang=js"
export * from "./CustomerEditQuotation.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditQuotation.vue?vue&type=style&index=0&id=62007d40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports